import React, { useEffect } from 'react'
import styled from '@emotion/styled'
import { IconWrapper } from 'UI/DownloadIconButton'
import CalendarIcon from '@material-ui/icons/CalendarToday'
import moment from 'moment'
import { Datepicker } from '@duik/it'

interface DateInputProps {
  date?: Date
  setDate?: (date: Date) => void
  buttonStyle?: React.ButtonHTMLAttributes<HTMLButtonElement>['style']
}

const StyledCalendarIcon = styled(CalendarIcon)`
  position: absolute;
  right: 16px;
  top: 6px;
  height: 24px;
  width: 24px;
  color: #ccc;
`

const DateInputButton = styled.button`
  background: none;
  color: #3e3f42;
  border: #e2e5ed solid 1px;
  border-radius: 4px;
  min-width: 200px;
  /* height: 18px; */
  padding: 10px 15px;
  position: relative;
  &:focus {
    border: #289c91 1px solid;
    border-radius: 4px;
    outline: none;
  }
  &:hover {
    border: #289c91 1px solid;
    cursor: pointer;
  }
`

const DateInputContainer = styled.div`
  position: relative;
  width: 100%;
`

const DateText = styled.div`
  display: flex;
  padding-right: 36px;
  margin-top: 2px;
`

const CalendarContainer = styled.div`
  position: absolute;
  top: 40px;
  left: 0px;
  width: 248px;
  z-index: 100;
  background-color: white;
  border: 1px solid #e2e5ed;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-content: center;
`

const DateInput: React.FC<DateInputProps> = ({ date, setDate, buttonStyle }) => {
  const [isOpen, setIsOpen] = React.useState(false)

  const dateInputRef = React.useRef<HTMLDivElement>(null)

  // Click outside to close
  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (dateInputRef.current && !dateInputRef.current.contains(event.target)) {
        setIsOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [dateInputRef])

  return (
    <DateInputContainer ref={dateInputRef}>
      <DateInputButton onClick={() => setIsOpen(true)} style={buttonStyle}>
        <DateText>{date ? moment(date).format('dddd, MMMM D, YYYY') : 'Select a date'}</DateText>
        <StyledCalendarIcon />
      </DateInputButton>
      {isOpen && (
        <CalendarContainer>
          <Datepicker
            isRange={false}
            onDateChange={d => {
              if (d && setDate) {
                setDate(d)
                setIsOpen(false)
              }
            }}
            value={date}
          />
        </CalendarContainer>
      )}
    </DateInputContainer>
  )
}

export default DateInput
